export default "__VITE_ASSET__DLmB$u0p__"